import React, { useState, useRef } from "react";

const VoiceNoteRecorder = ({ onAudioRecorded }) => {
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorderRef.current = new MediaRecorder(stream);
    audioChunksRef.current = [];

    mediaRecorderRef.current.ondataavailable = (e) => {
      if (e.data.size > 0) {
        audioChunksRef.current.push(e.data);
      }
    };

    mediaRecorderRef.current.onstop = () => {
      const blob = new Blob(audioChunksRef.current, { type: "audio/webm" });
      const url = URL.createObjectURL(blob);
      setAudioURL(url);

      const file = new File([blob], "voice_note.webm", { type: "audio/webm" });
      if (onAudioRecorded) onAudioRecorded(file);
    };

    mediaRecorderRef.current.start();
    setRecording(true);
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording(false);
  };

  const resetRecording = () => {
    setAudioURL(null);
    onAudioRecorded(null);
  };

  return (
    <div className="voice-note-container">
      {audioURL ? (
        <>
          <audio controls src={audioURL} />
          <div className="d-flex mt-2">
            <button
              type="button"
              className="btn btn-primary"
              onClick={resetRecording}
            >
              Re-record
            </button>
            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={resetRecording}
            >
              Cancel
            </button>
          </div>
        </>
      ) : recording ? (
        <button
          type="button"
          className="btn btn-danger"
          onClick={stopRecording}
        >
          Stop Recording
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-primary"
          onClick={startRecording}
        >
          Start Recording
        </button>
      )}
    </div>
  );
};

export default VoiceNoteRecorder;
